<div class="container__validation">
    <div class="container__validation__item" *ngFor="let validation of listValidation">
        <ng-container *ngIf="validation.type == 'match.location'">
            <img alt="resut" [src]="(validation?.status == StatusValidation.success) ? 'assets/icons/ubicacion_ok.svg' : (validation?.status == StatusValidation.wrong ? 'assets/icons/ubicacion_wrong.svg' : 'assets/icons/ubicacion_null.svg')">
        </ng-container>

        <ng-container *ngIf="validation.type == 'liveness.face'">
            <img alt="resut" [src]="(validation?.status == StatusValidation.success) ? 'assets/icons/selfie_Ok.svg' : ((validation?.status == StatusValidation.wrong) ? 'assets/icons/selfie_wrong.svg' : 'assets/icons/selfie_null.svg') ">
        </ng-container>

        <ng-container *ngIf="validation.type == 'match.face'">
            <img alt="resut" [src]="(validation?.status == StatusValidation.success) ? 'assets/icons/rostro_ok.svg' : ((validation?.status == StatusValidation.wrong) ? 'assets/icons/rostro_wrong.svg' : 'assets/icons/rostro_null.svg') ">
        </ng-container>
    </div>

</div>